var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"signup"},[_c('Sidebar'),_c('Form',{attrs:{"signup":false,"msg":"Sign In"},on:{"formSubmitted":function($event){return _vm.signinUser($event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }